// extracted by mini-css-extract-plugin
export default {"appCard":"appCard__jFIfs_","icon":"icon__rZn3by","cardName":"cardName__szAqmy"};